<ng-container>
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->

      <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        (click)="printPage()">
        Print
      </button>


      <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
        (click)="exportExcel('All_Total_Business_Subscription_Report')" mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered" style="table-layout: auto; width: 100%;">
        <thead>

     <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 5" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - कार्यालय प्रतिनिधीनिनुसार- प्रतिनिधीनिहाय 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->


                         <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span>
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

        
          <tr>
            <!-- <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></th>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></th> -->
            <th colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;  word-wrap: break-word;">प्रतिनिधींचे नाव</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">निव्वळ एकूण</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">योजना एकूण</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" colspan="4" style="border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; border-left: 2px solid black;">{{ data.name }}</th>
              <!-- <th *ngIf="data.isVisible" rowspan="2">रक्कम रुपये</th> -->
            </ng-container>

<!-- <th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">ठेवीदार </th> -->
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">देणगी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">कृषी विवेक </th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अशोकजी सिंघल विशेषांक नोंदणी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">शिवाजी विशेषांक नोंदणी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">नियमित अंक विक्री</th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">पुस्तक</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">राष्ट्रोत्थान निव्वळ ग्रंथ 2100/-</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">राष्ट्रोत्थान निव्वळ ग्रंथ 2500/-</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">विश्वसंचार संघाचा 2500</th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">पेंडींग व्यवसाय </th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

          </tr>

          <tr>
            <th colspan="3" style="border-bottom: 2px solid black; border-right: 2px solid black; border-left: 2px solid black;"></th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>

            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>

            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">वर्गणीदार संख्या</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <!-- <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->
            <!-- <th>रक्कम रुपये</th> -->
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
              <!-- <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->

            </ng-container>

<!-- <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th> -->
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">वर्गणीदार</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति </th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण रु.</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति </th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण रु.</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<!-- <th style="border-right: 2px solid black; word-wrap: break-word;">रक्कम</th> -->

          </tr>
        </thead>
        <tbody>
     


<ng-container *ngFor="let item of finalData">

  <!-- ================= FINAL TOTAL ================= -->
  <ng-container *ngIf="item?.name === 'एकूण'">
    <tr class="smallHeading">
      <td colspan="3" style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black; border-left: 2px solid black; border-top: 2px solid black;">{{ item.name }}</td>

      <!-- NET -->
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['net_नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['net_नूतनीकरण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['net_एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item['net_amount'] }}</td>

      <!-- YOJANA -->
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['yojana_नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['yojana_नूतनीकरण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['yojana_एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item['yojana_amount'] }}</td>

      <!-- MAIN -->
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item.sub }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item['नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item['नूतनीकरण'] }}</td>

      <!-- SUB TYPES -->
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ item[getKey(sub.name) + '_नवीन'] || 0}}</td>
          <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{(item[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{(item[getKey(sub.name) + '_नवीन'] || 0) + (item[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
          </td>
          <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_एकूण'] || 0 }}</td>
        </ng-container>
      </ng-container>

      <!-- DONATION -->
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item['देणगी_amount'] }}</td>

       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>

      <!-- PENDING + TOTAL -->
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ item['pending_amount'] || 0 }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ getRowTotal(item) || 0 }}</td>
    </tr>
  </ng-container>


  <!-- ================= OFFICE REP TOTAL ================= -->
  <ng-container *ngIf="item?.[0]?.isOfficeRepTotal">
    <tr class="smallHeading">
      <td colspan="3" style="text-align: right; border-left: 2px solid black; border-right: 2px solid black;">{{ item[0].name?.replace(' - एकूण', '') }}</td>

      <!-- NET -->
      <td style="text-align: right;">{{ item[0]['net_नवीन'] || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['net_नूतनीकरण'] || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['net_एकूण'] || 0 }}</td>
      <td style="text-align: right; border-right: 2px solid black;">{{ item[0]['net_amount'] || 0 }}</td>

      <!-- YOJANA -->
      <td style="text-align: right;">{{ item[0]['yojana_नवीन'] || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['yojana_नूतनीकरण'] || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['yojana_एकूण'] || 0 }}</td>
      <td style="text-align: right; border-right: 2px solid black;">{{ item[0]['yojana_amount'] || 0 }}</td>

      <!-- MAIN -->
      <td style="text-align: right;">{{ item[0].sub || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['एकूण'] || 0 }}</td>
      <td style="text-align: right;">{{ item[0]['नवीन'] || 0 }}</td>
      <td style="text-align: right; border-right: 2px solid black;">{{ item[0]['नूतनीकरण'] || 0 }}</td>

      <!-- SUB TYPES -->
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right;">{{ item[0][getKey(sub.name) + '_नवीन'] || 0 }}</td>
          <td style="text-align: right;">
            {{
              (item[0][getKey(sub.name) + '_नूतनीकरण'] || 0) +
              (item[0][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)
            }}
          </td>
          <td style="text-align: right;">
            {{
              (item[0][getKey(sub.name) + '_नवीन'] || 0) +
              (item[0][getKey(sub.name) + '_नूतनीकरण'] || 0) +
              (item[0][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)
            }}
          </td>
          <td style="text-align: right; border-right: 2px solid black;">{{ item[0][getKey(sub.name) + '_एकूण'] || 0}}</td>
        </ng-container>
      </ng-container>

      <!-- DONATION -->
      <td style="text-align: right; border-right: 2px solid black;">{{ item[0]['देणगी_amount'] }}</td>

          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>

      <!-- PENDING + TOTAL -->
      <td style="text-align: right; border-right: 2px solid black;">{{ item[0]['pending_amount'] || 0 }}</td>
      <td style="text-align: right; border-right: 2px solid black;">{{ getRowTotal(item[0]) || 0 }}</td>
    </tr>
  </ng-container>

</ng-container>



       
       
        </tbody>
      </table>
    </div>
  </div>

</ng-container>
<!-- <div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div> -->